import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FlagEditorComponent} from './components/flag-editor/flag-editor.component';
import {FlagViewerComponent} from './components/flag-viewer/flag-viewer.component';
import {PopupFlagEditorComponent} from './components/popup-flag-editor/popup-flag-editor.component';
import {FlagEditorDirective} from './directives/flag-editor.directive';



@NgModule({
  declarations: [
    FlagEditorComponent,
    FlagViewerComponent,
    PopupFlagEditorComponent,
    FlagEditorDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    FlagEditorComponent,
    FlagViewerComponent,
    PopupFlagEditorComponent,
    FlagEditorDirective,
  ]
})
export class FlagModule { }
